(() => {
  const toolbar = document.querySelector('[data-shop-toolbar]');
  if (!toolbar) return;

  const chips = [...toolbar.querySelectorAll('[data-filter]')];
  const grid = document.querySelector('[data-product-grid]') || document.querySelector('.product-grid');
  const cards = [...document.querySelectorAll('.product-card[data-category]')];
  const count = toolbar.querySelector('[data-result-count]');
  const totalProducts = Number(count?.dataset.totalProducts || cards.length);
  const sortSelect = toolbar.querySelector('[data-sort-products]');
  const CART_KEY = 'mangorace_preview_cart';
  let activeFilter = 'all';

  const readCart = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(CART_KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      localStorage.removeItem(CART_KEY);
      return [];
    }
  };

  const writeCart = (items) => {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
  };

  const formatMoney = (value) => `US$ ${Number(value || 0).toFixed(2)}`;

  const showToast = (message) => {
    document.querySelector('.site-toast')?.remove();
    const toast = document.createElement('div');
    toast.className = 'site-toast';
    toast.innerHTML = `<strong>${message}</strong><a href="./cart-preview.html">ViewCart</a>`;
    document.body.appendChild(toast);
    window.setTimeout(() => toast.classList.add('is-visible'), 20);
    window.setTimeout(() => toast.classList.remove('is-visible'), 2800);
    window.setTimeout(() => toast.remove(), 3300);
  };

  const sortCards = () => {
    if (!grid || !sortSelect) return;
    const sortedCards = [...cards].sort((a, b) => {
      const mode = sortSelect.value;
      const priceA = Number(a.dataset.priceValue || 0);
      const priceB = Number(b.dataset.priceValue || 0);
      const titleA = a.dataset.title || '';
      const titleB = b.dataset.title || '';
      if (mode === 'price-asc') return priceA - priceB;
      if (mode === 'price-desc') return priceB - priceA;
      if (mode === 'name') return titleA.localeCompare(titleB);
      return Number(a.dataset.order || 0) - Number(b.dataset.order || 0);
    });
    sortedCards.forEach((card) => grid.appendChild(card));
  };

  const applyFilter = (filter = activeFilter) => {
    activeFilter = filter;
    sortCards();
    let visible = 0;
    cards.forEach((card) => {
      const categories = (card.dataset.category || '').split(/\s+/);
      const shouldShow = filter === 'all' || categories.includes(filter);
      card.classList.toggle('is-hidden', !shouldShow);
      if (shouldShow) visible += 1;
    });
    if (count) {
      if (filter === 'all' && totalProducts > visible) {
        count.textContent = `Showing ${visible} of ${totalProducts} products`;
      } else {
        count.textContent = `Showing ${visible} products`;
      }
    }
  };

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      chips.forEach((item) => item.classList.remove('is-active'));
      chip.classList.add('is-active');
      applyFilter(chip.dataset.filter || 'all');
    });
  });

  sortSelect?.addEventListener('change', () => applyFilter(activeFilter));

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-add-preview-cart]');
    if (!button) return;
    const card = button.closest('.product-card');
    if (!card) return;
    const productId = button.dataset.addPreviewCart;
    const price = Number(card.dataset.priceValue || 0);
    if (!productId || price <= 0) return;
    const items = readCart();
    const existing = items.find((item) => item.id === productId);
    if (existing) {
      existing.quantity = Math.min(9, Number(existing.quantity || 0) + 1);
    } else {
      items.push({
        id: productId,
        title: card.dataset.title || card.querySelector('h3')?.textContent || 'MangoRace Product',
        price,
        quantity: 1,
        href: `./product-detail.html?product=${productId}`,
        action: 'ViewProducts',
        color: card.dataset.color || 'linear-gradient(135deg, var(--accent), var(--accent-warm))',
        description: card.dataset.cartDescription || card.querySelector('p')?.textContent || 'MangoRace Products'
      });
    }
    writeCart(items);
    showToast(`Added to cart · ${formatMoney(price)}`);
  });

  applyFilter('all');
})();
